import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTheme } from '@ifit/themes/withTheme';
import './index.scss';

export const Dialog = ({
  heading,
  message,
  children,
  primaryAction,
  secondaryAction,
  primaryLabel,
  secondaryLabel,
  themeClass,
  className,
  ...rest
}) => (
  <div className={classNames('rc-dialog', themeClass, className)} {...rest}>
    <div className="rc-dialog-content">
      {heading && <h3>{heading}</h3>}
      {message && <p>{message}</p>}
      {children && <div>{children}</div>}
    </div>
    <div className="rc-dialog-buttons">
      {primaryLabel && (
        <button className="primary" onClick={primaryAction}>
          {primaryLabel}
        </button>
      )}
      {secondaryLabel && (
        <button className="secondary" onClick={secondaryAction}>
          {secondaryLabel}
        </button>
      )}
    </div>
  </div>
);

Dialog.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string,
  children: PropTypes.node,
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  themeClass: PropTypes.string,
  className: PropTypes.string,
};

Dialog.defaultProps = {
  primaryAction: () => {},
  secondaryAction: () => {},
};

export default withTheme(Dialog);
